/**
 * @generated SignedSource<<4017025d370b896c7645128579d5ac13>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedSellerItemsCarousel_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedProductTileCarousel_user">;
  readonly " $fragmentType": "PdpSharedSellerItemsCarousel_user";
};
export type PdpSharedSellerItemsCarousel_user$key = {
  readonly " $data"?: PdpSharedSellerItemsCarousel_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSellerItemsCarousel_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedSellerItemsCarousel_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedProductTileCarousel_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "7cea595d5899c61bfda88cab30de045a";

export default node;
